export default "__VITE_ASSET__b41e0744__"